import { Page } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { EntryList } from '@/features/time/EntryList';
import { useRunningEntry } from '@/features/time/hooks';
import { TimerBar } from '@/features/time/TimerBar';

export default function TrackerPage() {
  // The timer bar needs to know whether a timer is running before it can show START or STOP.
  const running = useRunningEntry();
  return (
    <Page>
      <h1 className="sr-only">Time Tracker</h1>
      {running.isPending ? (
        <Skeleton aria-label="Loading timer" className="mb-6 h-14 w-full" />
      ) : running.isError ? (
        // Not the timer and list: they would re-request the failed query on mount, which puts it
        // back to pending (no data yet), unmounting them again — an endless request loop.
        <div
          role="alert"
          className="flex flex-wrap items-center justify-between gap-3 rounded-md border bg-card p-4 text-destructive"
        >
          <span>Couldn’t load the Time Tracker. {running.error.message}</span>
          <Button variant="outline" onClick={() => running.refetch()}>
            Retry
          </Button>
        </div>
      ) : (
        <>
          <TimerBar />
          <EntryList />
        </>
      )}
    </Page>
  );
}
